import React from "react";
import BaseCard from "../../../components/ui/BaseCard";
import BaseCheckbox from "../../../components/ui/BaseCheckbox";
import { useFormik } from "formik";
import useAuth from "../../../hooks/useAuth";
import { useParams } from "react-router-dom";
import {
  createDesignationPermissions,
  fetchAllPermissionsByDesignation,
} from "../../../services/api/designation";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ModuleType } from "../../../utils/enum";
import { getDesignationPermissionsByModule } from "../../../utils/getDesignationPermissionsByModule";

const TaskBoardPermissions = ({
  designationPermissions,
  designationId,
  refetchAllPermissionsByDesignation,
}) => {
  const taskBoardPermissions = getDesignationPermissionsByModule(
    designationPermissions,
    ModuleType.TASK_BOARD,
  );

  const {
    isPending: isCreateDesignationPermissionsApiLoading,
    error: isCreateDesignationPermissionsApiError,
    mutateAsync: createDesignationPermissionsMutation,
  } = useMutation({
    mutationFn: createDesignationPermissions,
    enabled: false,
  });

  const formik = useFormik({
    initialValues: {
      TASK_BOARD: {
        isRead: taskBoardPermissions.hasReadAccess,
        isWrite: taskBoardPermissions.hasWriteAccess,
        isUpdate: taskBoardPermissions.hasUpdateAccess,
        isDelete: taskBoardPermissions.hasDeleteAccess,
      },
    },
    onSubmit: (values) => {
      // Replace with your actual submit handler
      // handleConfirmApprovalButton(values);
    },
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
    validateOnMount: true,
  });

  const handleTaskBoardPermissionsChange = async (e, value, module, permissionId) => {
    try {
      formik.setFieldValue(e.target.name, e.target.checked);
      const payload = {
        ...formik.values.TASK_BOARD,
        [value]: e.target.checked,
        module,
        designationId: +designationId,
        permissionId,
      };

      await createDesignationPermissionsMutation(payload);
      await refetchAllPermissionsByDesignation();
    } catch (error) {}
  };

  return (
    <BaseCard elevation={0} className="p-5 rounded-lg">
      <div className="pb-4">
        <p className="text-dark text-base font-normal mb-2">Task Board</p>
        <div className="grid grid-cols-7">
          <BaseCheckbox
            label="Read Task Board"
            name="WORK_FORCE_TALENT_POOL.isRead"
            checked={formik.values.TASK_BOARD.isRead}
            onChange={(e) =>
              handleTaskBoardPermissionsChange(
                e,
                "isRead",
                ModuleType.TASK_BOARD,
                taskBoardPermissions.permissionId,
              )
            }
          />

          {/* <BaseCheckbox
            label="Create Task"
            name="TASK_BOARD.isWrite"
            checked={formik.values.TASK_BOARD.isWrite}
            onChange={(e) =>
              handleTaskBoardPermissionsChange(
                e,
                "isWrite",
                ModuleType.TASK_BOARD,
                taskBoardPermissions.permissionId,
              )
            }
          /> */}

          {/* <BaseCheckbox
            label="Update Task"
            name="TASK_BOARD.isUpdate"
            checked={formik.values.TASK_BOARD.isUpdate}
            onChange={(e) =>
              handleTaskBoardPermissionsChange(
                e,
                "isUpdate",
                ModuleType.TASK_BOARD,
                taskBoardPermissions.permissionId,
              )
            }
          /> */}

          {/* <BaseCheckbox
            label="Remove Task"
            name="TASK_BOARD.isDelete"
            checked={formik.values.TASK_BOARD.isDelete}
            onChange={(e) =>
              handleTaskBoardPermissionsChange(
                e,
                "isDelete",
                ModuleType.TASK_BOARD,
                taskBoardPermissions.permissionId,
              )
            }
          /> */}
        </div>
      </div>
    </BaseCard>
  );
};

export default TaskBoardPermissions;
